export const generateBufferPointId = (entityId: string, index: number) => `${entityId}-point-${index}`;
